import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { MntListBlock } from '../../interfaces/maintenance';
import { DashEmpty } from '../dashboard/personal/DashSection';

/** "CODE Name" for a machine, falling back to the place. */
export const machineLabel = (code?: string | null, name?: string | null, place?: string | null): string => {
    const m = [code, name].filter(Boolean).join(' ');
    return m || place || '-';
};

export const fmtShortDate = (iso?: string | null): string => {
    if (!iso) return '-';
    const d = new Date(iso.length === 10 ? `${iso}T00:00:00` : iso);
    return Number.isNaN(d.getTime()) ? '-' : d.toLocaleDateString();
};

export const fmtMinutesShort = (m?: number | null): string => {
    if (m === undefined || m === null) return '-';
    const h = Math.floor(m / 60);
    return h > 0 ? `${h}h ${m % 60}m` : `${m}m`;
};

interface DashListProps<T> {
    block: MntListBlock<T> | undefined;
    empty: string;
    testId: string;
    keyOf: (row: T) => string;
    render: (row: T) => React.ReactNode;
}

/** A capped list block: rows, plus "and N more" when the server holds more than it sent. */
export function DashList<T>({ block, empty, testId, keyOf, render }: DashListProps<T>) {
    if (!block || block.items.length === 0) return <DashEmpty text={empty} />;
    const more = block.total - block.items.length;
    return (
        <Stack spacing={1} divider={<Box sx={{ borderTop: 1, borderColor: 'divider' }} />} data-testid={testId}>
            {block.items.map(row => (
                <Stack key={keyOf(row)} direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap>
                    {render(row)}
                </Stack>
            ))}
            {more > 0 && <Typography variant="caption" color="text.secondary">and {more} more</Typography>}
        </Stack>
    );
}
